export const SERVICES = [
  {
    slug: 'business-growth',
    title: 'Business Growth Solutions',
    short: 'Helping SMEs scale with strategy, sales planning and market entry support.',
    items: [
      'Business Development Strategy',
      'Sales Growth Planning',
      'Partnership Development',
      'Market Entry Support',
      'Business Process Improvement',
    ],
    icon: 'TrendingUp',
    accent: 'gold',
    size: 'lg',
  },
  {
    slug: 'workforce',
    title: 'Workforce Solutions',
    short: 'End-to-end recruitment support — sourcing, screening, and workforce planning.',
    items: [
      'Candidate Sourcing',
      'CV Screening',
      'Recruitment Support',
      'Interview Coordination',
      'Talent Database Management',
      'Workforce Planning',
    ],
    icon: 'Users',
    accent: 'blue',
    size: 'md',
  },
  {
    slug: 'employer-branding',
    title: 'Employer Branding',
    short: 'Become an employer that top talent wants to join.',
    items: [
      'Career Page Development',
      'Job Description Development',
      'Recruitment Campaign Support',
      'Employer Branding Strategy',
    ],
    icon: 'Sparkles',
    accent: 'slate',
    size: 'md',
  },
  {
    slug: 'hr-technology',
    title: 'HR Technology Solutions',
    short: 'Digitise recruitment with the right ATS, workflows and advisory.',
    items: [
      'Applicant Tracking System Implementation',
      'Recruitment Workflow Optimization',
      'Digital Recruitment Advisory',
    ],
    icon: 'Cpu',
    accent: 'blue',
    size: 'md',
  },
  {
    slug: 'career-development',
    title: 'Career Development',
    short: 'Help professionals position themselves and land the right roles.',
    items: [
      'CV Writing',
      'LinkedIn Profile Optimization',
      'Interview Preparation',
      'Career Coaching',
    ],
    icon: 'GraduationCap',
    accent: 'slate',
    size: 'md',
  },
  {
    slug: 'corporate-services',
    title: 'Corporate Services',
    short: 'Full-spectrum business setup and government liaison in the UAE.',
    items: [
      'Business Setup Support',
      'PRO Services',
      'Trade License Assistance',
      'Government Liaison Services',
    ],
    icon: 'Building2',
    accent: 'gold',
    size: 'lg',
  },
];

export const INDUSTRIES = [
  { name: 'Construction', icon: 'HardHat', desc: 'Skilled labour, site management talent, and compliance-ready hiring.' },
  { name: 'Real Estate', icon: 'Home', desc: 'Brokers, property managers, and back-office talent for fast-moving teams.' },
  { name: 'SMEs', icon: 'Briefcase', desc: 'Lean, high-impact hiring and growth support for owner-led businesses.' },
  { name: 'Manufacturing', icon: 'Factory', desc: 'Operations, supervisory and technical roles across light & heavy manufacturing.' },
  { name: 'Professional Services', icon: 'Scale', desc: 'Finance, legal, consulting, and advisory talent.' },
  { name: 'Retail', icon: 'ShoppingBag', desc: 'Store, supervisory and head-office hiring with rapid turnaround.' },
  { name: 'Logistics', icon: 'Truck', desc: 'Warehouse, fleet, and supply-chain workforce solutions.' },
];

export const VALUES = [
  { name: 'Integrity', desc: 'We do what is right, even when no one is watching.' },
  { name: 'Professionalism', desc: 'Disciplined execution at every touchpoint.' },
  { name: 'Innovation', desc: 'Smarter ways to connect businesses with talent.' },
  { name: 'Customer Focus', desc: 'Your outcomes shape every decision we make.' },
  { name: 'Excellence', desc: 'High standards, raised quietly and consistently.' },
  { name: 'Collaboration', desc: 'We work alongside you — not at arm\'s length.' },
];

export const WHY_US = [
  { title: 'Experienced Business Professionals', desc: 'Deep backgrounds in banking, business development, real estate, and relationship management.' },
  { title: 'Personalized Business Solutions', desc: 'Every engagement is shaped around the business in front of us — never a template.' },
  { title: 'Technology-Driven Approach', desc: 'Modern tools and digital workflows that compound efficiency over time.' },
  { title: 'Customer-Centric Service', desc: 'Responsive, accountable and easy to work with from day one.' },
  { title: 'Strategic Partnerships', desc: 'A network of vetted partners across recruitment, technology and corporate services.' },
  { title: 'Professional Integrity', desc: 'Honest advice — even when it is not the easy answer.' },
];
